export class HealthCarrier {
  id: number
  idMotion: number
  name: string

  constructor({ id, idMotion, name } = {} as any) {
    this.id = Number(id)
    this.idMotion = Number(idMotion)
    this.name = name
  }

  get isPrivate() {
    return this.id === 131
  }

  convertFromAlgolia(hit) {
    this.id = Number(hit.id)
    this.idMotion = Number(hit.idMotion)
    this.name = hit.name

    return this
  }

  private() {
    this.id = 131
    this.idMotion = 7719
    this.name = 'Particular'

    return this
  }
}
